<template>
    <div class="message is-success" v-if="message">
        <div class="message-body">
            {{ message }}
        </div>
    </div>
</template>
<script>
export default {
    props : {
        message: String
    }
}
</script>
